import LichThiDauKQV3 from "../LichThiDauKQV3";

const KbvLichThiDauV3 = () => <LichThiDauKQV3 />;

export default KbvLichThiDauV3;
